import React from "react";
import Section, { FadeIn } from "@/components/Section";
import { BRAND } from "@/lib/brand";

export default function ImpressumPage() {
  return (
    <div data-testid="impressum-page" className="pt-36 lg:pt-44">
      <Section padded={false} className="pb-32">
        <FadeIn>
          <div className="max-w-3xl">
            <div className="overline mb-6">Rechtliches</div>
            <h1 className="font-display text-5xl lg:text-6xl tracking-[-0.02em] text-white leading-[1.02]">
              Impressum
            </h1>

            <div className="mt-16 space-y-12 text-white/70 text-[15.5px] leading-relaxed">
              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  Angaben gemäß § 5 TMG
                </h2>
                <p>
                  {BRAND.company}
                  <br />
                  Inhaber: {BRAND.name}
                  <br />
                  {BRAND.address.street}
                  <br />
                  {BRAND.address.city}
                  <br />
                  {BRAND.address.country}
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  Kontakt
                </h2>
                <p>
                  Telefon: {BRAND.phone}
                  <br />
                  E-Mail: {BRAND.email}
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                </h2>
                <p>
                  {BRAND.name}
                  <br />
                  {BRAND.address.street}, {BRAND.address.city}
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  Streitschlichtung
                </h2>
                <p>
                  Die Europäische Kommission stellt eine Plattform zur
                  Online-Streitbeilegung (OS) bereit:{" "}
                  <a
                    href="https://ec.europa.eu/consumers/odr"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="link-underline text-white"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                  . Wir sind nicht bereit oder verpflichtet, an
                  Streitbeilegungs­verfahren vor einer
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  Haftung für Inhalte & Links
                </h2>
                <p>
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt
                  erstellt. Für die Richtigkeit, Vollständigkeit und
                  Aktualität der Inhalte können wir jedoch keine Gewähr
                  übernehmen. Für Inhalte verlinkter externer Seiten ist
                  stets der jeweilige Anbieter oder Betreiber verantwortlich.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  Urheberrecht
                </h2>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke
                  unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
                  Bearbeitung, Verbreitung oder jede Art der Verwertung
                  außerhalb der Grenzen des Urheberrechtes bedarf der
                  schriftlichen Zustimmung des jeweiligen Autors bzw.
                  Erstellers.
                </p>
              </section>

              <div className="pt-6 border-t border-white/[0.08] text-white/45 text-[13px] italic">
                Hinweis: Dieses Impressum ist ein sorgfältig erstellter
                Entwurf. Bitte lassen Sie die rechtlichen Angaben vor
                Veröffentlichung von einer fachkundigen Stelle (z.&nbsp;B.
                Anwalt oder IHK) final prüfen.
              </div>
            </div>
          </div>
        </FadeIn>
      </Section>
    </div>
  );
}
